import $ from 'jquery';
import screenSize from '../services/screen_size';
import featureFlags from '../../../../../feature_flags';
import adManager from '../services/admanager';
/*
This module will handle the functionalities of welcome ad.
Here's the flow:
1) This module exposes the initWelcomeAd function to window.FCAdops global variable namespace
2) Adops sets up a scheduled trigger for welcome ad via a mezzobit tag: https://tdi.mezzobit.com/tag, look for welcomeadV2Test
3) The Welcome ad itself checks for certain conditions, such as frequency cap or is ipad only. Then it uses cookie (fc_splash) to ensure the user do not see welcome ad within the timeframe specified.

Note:
- We also disable the welcome ad for users coming from certain social media networks.
- This feature is currently hiding behind feature flag, we're disabling it until we can use it in Q4
- To test this: 1)enable feature flag 2)Add welcomeadV2Test to tag container 3)go to site with ?adzone=qa param, if you don't see the ad, be sure to check if the cookie fc_splash is set, if so, remove it.
*/
const start = () => {
    exposeWelcomeAdFunction();
    welcomeAdEventHandlers();

};

const exposeWelcomeAdFunction = () => {
    // Expose this function as a public function for Adops to call
    window.FCAdops = window.FCAdops || {};
    window.FCAdops.initWelcomeAd = initWelcomeAd;
};

const welcomeAdEventHandlers = () => {
    $('.welcome-ad-modal-content, .welcome-modal-close').on('click', function () {
        $('.welcome-ad-modal').fadeOut();
    });

    // Dynamically adjust close button position based on the ad sizes returned, the ad can be either 600px or 640px wide
    $(window).on('adLoaded', function (event, ad) {
        if (ad.slot.G.indexOf('/welcome') !== -1) {
            var welcomeAdWidth = ad.size[0];
            $('.welcome-modal-close').css('width', welcomeAdWidth + 'px').fadeIn();
        }
    });
};

const initWelcomeAd = (frequency, ipadOnly, isVideo) => {
    var settings = {
        'frequency': frequency,
        'ipadOnly': ipadOnly,
        'isVideo': isVideo
    };

    // Note: the following module was copied from previous codebase, it seems to work well for adops, so there was minimal changes to it
    var welcomeAd = {
        freq: settings.frequency, //frequency cap in hours
        ipadOnly: settings.ipadOnly || false,
        isVideo: settings.isVideo || false,
        enabled: true,

        mobiles: [
            "iphone",
            "ipod",
            "blackberry",
            "android",
            "motorola"],

        start: function () {
            // dont do this when it's mobile
            if (!this.isMobile()) {
                var isIpad = this.isIpad();
                var isSocial = this.isSocialReferrer();

                // If it's enabled, and user referrer is not social media
                if (this.enabled === true && isSocial === false) {
                    if (this.ipadOnly === true && isIpad === false) {
                        //ipad only, user is not an ipad, exit
                        return;
                    }
                    this.showWelcome();

                } else {
                    // console.log('no welcome ad enabled,or cookie already set, returning...');
                    return;
                }
            }
        },

        showWelcome: function () {
            if (this.readCookie('fc_splash') === null) {

                // console.log('welcome enabled, no cookie fc_splash found, setting a cookie, redirecting user');
                if (this.freq !== 0) {
                    this.createCookie('fc_splash', 1, this.freq);
                }
                // console.log('cookie set, expiring in ' + this.freq + ' hours');

                if (this.isVideo) {
                    this.showWelcomeAdVideo();
                } else {
                    $('.welcome-ad-modal').show();
                }
            } else {
                // console.log('cookie already set, returning...');
                return;
            }
        },

        showWelcomeAdVideo: function () {
            // Set up ad div for welcome ad pixel
            $('.welcome-ad-video').before(`<div class="ad-unit welcome-ad-video-tracking-pixel"
                data-advertising="welcome_ad_video_pixel">
                <div class="dart-ad"></div>
            </div>`);
            adManager();
        },

        createCookie: function (name, value, hours) {
            var expires = '';
            var date = new Date();

            if (hours) {
                date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
                expires = "; expires=" + date.toGMTString();
            }

            document.cookie = name + "=" + value + expires + "; path=/";
        },

        isMobile: function () {
            var mobiles = this.mobiles;
            var uagent = navigator.userAgent.toLowerCase();
            var mobilesLength = mobiles.length;

            for (var i = 0; i < mobilesLength; i++) {
                if (uagent.search(mobiles[i]) > -1) {
                    return true;
                }
            }
            return false;
        },

        isIpad: function () {
            var uagent = navigator.userAgent.toLowerCase();
            if (uagent.search('ipad') > -1) {
                return true;
            }

            return false;
        },

        readCookie: function (name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            var caLength = ca.length;
            var c = [];

            for (var i = 0; i < caLength; i++) {
                c = ca[i];

                while (c.charAt(0) === ' ') {
                    c = c.substring(1, c.length);
                }

                if (c.indexOf(nameEQ) === 0) {
                    return c.substring(nameEQ.length, c.length);
                }
            }
            return null;
        },

        isSocialReferrer: function () {
            // Check the user referrer against a previously defined list of social networks
            var index;  //for loop count
            var isSocial = false; //Defaults to false

            // list of known domain names from various social media sites
            var socialMediaSites = [
                'facebook.com/',
                'fb.me/',
                'twitter.com/',
                't.co/',
                'lnkd.in/',
                'linkedin.com/',
                'stumbleupon.com/',
                'su.pr/',
                'pinterest.com/',
                'tumblr.com/'
            ];

            var userReferrer = document.referrer.toLowerCase();

            // If found, set isSocial to true
            for (index = 0; index < socialMediaSites.length; index++) {
                if (userReferrer.indexOf(socialMediaSites[index]) !== -1) {
                    isSocial = true;
                }
            }
            return isSocial;
        }
    };

    // Do not do welcome ad on small screens, put it behind feature flag for now
    if (screenSize.getSize() !== 'small' && featureFlags.welcomeAdV2) {
        welcomeAd.start();
    }
};

export default start;
